import isCorrectHatchIdFormat from 'utils/isCorrectHatchIdFormat';

import { SET_FRESH_ORGANIZATION_KEY } from '../constants';

export const doSetFreshOrganizationKey =
  ({ key, organizationIDs, fresh }) =>
  async ({ dispatch }) => {
    // if no boardId or no key to update, then we're done
    if (!key || !organizationIDs.every(isCorrectHatchIdFormat))
      return dispatch({
        payload: 'doSetFreshOrganizationKey',
        type: 'BAILOUT',
      });

    // make the given key on the board object fresh
    return dispatch({
      payload: { fresh, key, organizationIDs },
      type: SET_FRESH_ORGANIZATION_KEY,
    });
  };
